<div class="flex flex-col justify-center items-center min-h-screen bg-gray-900">
  <img src="../../../../assets/logo.svg" alt="Loading logo" class="w-80 mb-8" />
  <div class="flex space-x-4">
    <span class="w-3 h-3 bg-orange-500 rounded-full animate-scale-dots" style="animation-delay: 0s !important;"></span>
    <span class="w-3 h-3 bg-orange-500 rounded-full animate-scale-dots" style="animation-delay: 0.2s !important;"></span>
    <span class="w-3 h-3 bg-orange-500 rounded-full animate-scale-dots" style="animation-delay: 0.4s !important;"></span>
  </div>
</div>

